import { render, staticRenderFns } from "./SpecializationInfo.vue?vue&type=template&id=794b6038&scoped=true"
import script from "./SpecializationInfo.vue?vue&type=script&lang=js"
export * from "./SpecializationInfo.vue?vue&type=script&lang=js"
import style0 from "./SpecializationInfo.vue?vue&type=style&index=0&id=794b6038&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794b6038",
  null
  
)

export default component.exports